import { useEffect, useState } from 'react';
export const useAccessToken = () => {
  const [token, setToken] = useState(() => localStorage.getItem('access-token'));

  useEffect(() => {
    const syncToken = () => {
      setToken(localStorage.getItem('access-token'))
    };
    window.addEventListener('storage', syncToken);
    window.addEventListener('access-token-updated', syncToken);
    return () => {
      window.removeEventListener('storage', syncToken);
      window.removeEventListener('access-token-updated', syncToken);
    };
  }, []);

  return token;
};
